module.exports = __webpack_public_path__ + "static/img/logo_qm.f9f94b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_qm.png
// module id = ouk5
// module chunks = 15